import { useCallback } from 'react'
import PropTypes from 'prop-types'

import { Button, IconButton, TextField } from 'basic-components'
import { Clear } from 'basic-components/icons'

import { When } from 'react-if'

import './Column.scss'

const EMPTY_ARRAY = []

const Column = ({ columns, columnsName, index, name = "", onChange, values = EMPTY_ARRAY }) => {
  const onChangeLocal = useCallback((value, { name }) => onChange(columns.updateInList({ [name]: value }, index), { name: columnsName }), [columns, columnsName, index, onChange]),
        onChangeColumnValues = useCallback((value, { index }) => onChangeLocal(values.replace(value, index), { name: "values" }), [onChangeLocal, values]),
        onRemoveColumn = useCallback(() => onChange(columns.remove(index), { name: columnsName }), [columns, columnsName, index, onChange]),
        onRemoveValue = useCallback(index => onChangeLocal(values.remove(index), { name: "values" }), [onChangeLocal, values]),
        onAddValue = useCallback(() => onChangeLocal(values.add(""), { name: "values" }), [onChangeLocal, values])
  return (
    <div className="data-lake__group-dialog__advanced__column-row">
      <IconButton
          className="data-lake__group-dialog__advanced__column-row__remove"
          onClick={onRemoveColumn}
          type="button"
      >
        <Clear
            height={16}
            width={16}
        />
      </IconButton>
      <TextField
          defaultValue={name}
          name="name"
          noError
          onChange={onChangeLocal}
          placeholder="Name RegExp"
          size="small"
      />
      <div className="data-lake__group-dialog__advanced__column-row__values">
        {values.map((value, valueIndex) => (
          <div
              className="data-lake__group-dialog__advanced__column-row__values__row"
              key={valueIndex}
          >
            <TextField
                defaultValue={value}
                name="values"
                noError
                onChange={value => onChangeColumnValues(value, { index: valueIndex })}
                placeholder="Value RegExp"
                size="small"
            />
            <When condition={values.length > 1}>
              {() => (
                <IconButton
                    className="data-lake__group-dialog__advanced__column-row__values__row__clear"
                    onClick={() => onRemoveValue(valueIndex)}
                    type="button"
                >
                  <Clear
                      height={16}
                      width={16}
                  />
                </IconButton>
              )}
            </When>
          </div>
        ))}
        <div className="data-lake__group-dialog__advanced__column-row__values__add">
          <Button
              onClick={onAddValue}
              size="small"
              type="button"
              variant="text"
          >
            Add value
          </Button>
        </div>
      </div>
    </div>
  )
}

Column.propTypes = {
  columns: PropTypes.array.isRequired,
  columnsName: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  values: PropTypes.array,
}

export default Column
